import type { AllRouteEndpoints } from "../routeTypes";

export const postAppGroupIdFigmaImagesCacheKeys: AllRouteEndpoints[] = [];
